<template>
    <v-col cols="12">
        <v-row no-gutters>
            <AppStoreTabsItems
                v-model="selectedTab"
                :all-tabs="tabs"
            >
                <template v-slot:content="{tab}">
                    <component
                        :is="tab.component"
                        :is-selected="selectedTabName === tab.name"
                    />
                </template>
            </AppStoreTabsItems>
        </v-row>
    </v-col>
</template>

<script>
import { ref, computed } from "@vue/composition-api";
import { $t } from "@/i18n";
import AppStoreTabs from "@/components/AppStore/AppStoreDialogTabs";
import AppStoreTabsItems from "@/components/AppStore/AppStoreDialogTabsItems";
import appStoreDialog from "@/store/modules/AppStoreDialog/appStoreDialog";
import { TAB_NAMES } from "@/views/AppStore/app-tabs";
import AccountModule from "@/store/modules/account";
import {APP_STORE_APP_TYPES} from "@/helpers/constants";

export default {
    name: "ClientsDialogContent",
    components: {
        AppStoreTabs,
        AppStoreTabsItems
    },
    props: {
        defaultTab: {
            type: String,
            default: ''
        }
    },
    setup(props, { root }) {
        const {isFeatureEnabled} = AccountModule();

        const { appStoreDialogActions, appStoreDialogGetters, appStoreDialogFlags } = appStoreDialog()
        const allTabs = ref([
            {
                id: 1,
                name: TAB_NAMES.OVERVIEW,
                text: $t("Overview"),
                component: () => import("./ClientsDialogOverviewTab.vue"),
            },
            {
                id: 2,
                name: TAB_NAMES.SETTINGS,
                text: $t("Settings"),
                component: () => import("./ClientPortalSettingsTab.vue"),
                if: appStoreDialogFlags.canSeeAllTabs
            },
            {
                id: 3,
                name: TAB_NAMES.TEMPLATES,
                text: $t("Templates"),
                component: () => import("./ClientPortalTemplatesTab.vue"),
                if: appStoreDialogFlags.canSeeAllTabs
            },
            {
                id: 4,
                name: TAB_NAMES.MENU_LINKS,
                text: $t("Menu links"),
                component: () => import("./ClientPortalMenuLinksTab.vue"),
                if: () => appStoreDialogFlags.canSeeAllTabs() && isFeatureEnabled(appStoreDialogGetters.getSelectedCompany().id, APP_STORE_APP_TYPES.CLIENT_PORTAL_MENU, false)
            }
        ]);

        appStoreDialogActions.setTabs(allTabs);
        const tabs = computed(() => appStoreDialogGetters.getTabs());
        const selectedTab = computed(() => appStoreDialogGetters.getSelectedTab());
        const selectedTabName = computed(() => appStoreDialogGetters.getSelectedTabName());

        if (props.defaultTab){
            appStoreDialogActions.updateCurrentTab(props.defaultTab)
        }

        return {
            selectedTab,
            tabs,
            selectedTabName
        };
    }
};
</script>